import React from 'react';
import cs from 'classnames';
import noop from 'lodash/noop';
import Tags from './Tags';

import css from './index.css';

import {connect} from 'react-redux';
const MAXLENGTH = {
  number: 6,
};

const dataQa = (prefix, postfix) => {
  if (!prefix) {
    return null;
  }

  if (!postfix) {
    return prefix;
  }

  return `${prefix}-${postfix}`;
};

class LabeledInput extends React.Component {
  // need to be class b/c of 'ref'
  constructor() {
    super();
    this.onFocus = this.onFocus.bind(this);
    this.saveInput = this.saveInput.bind(this);
  }

  componentWillMount() {
    if (this.props.autoFocus) {
      this.setState({willAutoFocus: true});
    }
  }

  componentDidMount() {
    if (this.state && this.state.willAutoFocus) {
      this.input.focus();
    }
  }

  render() {
    const props = this.props;
    const contents = props.children ? props.children : this.renderInput(props);

    if (props.label) {
      return (
        <label className={cs(props.wrapClassName, 'qa-label')}>
          <div className={cs(css.label, {
            [css.whiteLabel]: props.isWhiteLabel,
            [css.hugeLabel]: props.hugeInput,
            [css.greyLabel]: props.greyLabel,
            [css.blackLabel]: props.blackLabel,
          })}
          >
            {props.label}
          </div>
          {contents}
          {props.touched && props.error && <div className={css.error}>{props.error}</div>}

        </label>
      );
    }
    return contents;
  }

  renderInput(props) {
    const prefix = this.props['data-qa'];
    const isShowPlaceholder = !(props.tags && props.value && props.value.length);
    if (props.textarea) {
      return (
        <textarea
          data-qa={dataQa(prefix, '')}
          className={cs(css.input, css.textarea, 'qa-input', {
            [css.tallInput]: props.tallInput,
            [css.hugeInput]: props.hugeInput,
            [css.focused]: props.toggled,
            [css.button]: props.readOnly,
            [css.mediumInput]: props.mediumInput,
          })}
          placeholder={props.placeholder}
          value={props.value || ''}
          ref={this.saveInput}
          onChange={props.onChange}
          readOnly={props.readOnly}
          onKeyPress={props.onKeyPress}
          onKeyUp={props.onKeyUp}
          onKeyDown={props.onKeyDown}
          onInput={props.onInput}
          onBlur={props.onBlur}
          onFocus={this.onFocus}
          name={props.name || ''}
          autoComplete = {props.autoComplete}
        />
      );
    }

    const input = (
      <input
        data-qa={dataQa(prefix, '')}
        className={cs(css.input, 'qa-input', props.inputClassName, {
          [css.tallInput]: props.tallInput,
          [css.hasIcon]: props.icon,
          [css.hugeInput]: props.hugeInput,
          [css.focused]: props.toggled && !props.greyOutline,
          [css.button]: props.readOnly,
          [css.capitalize]: props.capitalize,
          [css.hasLeftIcon]: props.icon && props.iconLeft,
          [css.large]: props.large,
          [css.mediumInput]: props.mediumInput,
        })}
        type={props.type === 'password' ? 'password' : 'text'}
        maxLength={MAXLENGTH[props.type]}
        placeholder={isShowPlaceholder ? props.placeholder : ''}
        value={props.tags ? noop() : props.value}
        ref={this.saveInput}
        onChange={props.onChange}
        readOnly={props.readOnly || props.tags}
        onKeyPress={props.onKeyPress}
        onKeyUp={props.onKeyUp}
        onKeyDown={props.onKeyDown}
        onInput={props.onInput}
        onBlur={props.onBlur}
        onFocus={this.onFocus}
        id={props.id}
        name={props.name || ''}
        autoComplete = {props.autoComplete}
      />
    );

    if (props.icon) {
      const isLoggedIn = props.isLoggedIn ? props.isLoggedIn : false;
      return (
        <div className={cs(css.wrap4icon, {[css.button]: props.readOnly}, 'qa-field')}
          data-isLoggedIn={isLoggedIn} onClick={props.onSelectBroker}
        >
          {input}
          {props.tags
            ? <Tags wrapperClassName={cs(css.tagsWrap, {
              [css.tagsWrapAligned]: (props.tallInput || props.hugeInput),
              [css.tagsHuge]: (props.hugeInput),
            })} data-qa={dataQa(prefix, 'tags')} tags={props.value}
              hugeTag={props.hugeInput}
            />
            : null
          }
          <span
            className={cs(css.icon, css[props.icon], 'qa-input-icon', {
              [css.focused]: props.toggled,
              [css.iconAligned]: (props.tallInput || props.hugeInput),
            })}
            data-qa={dataQa(prefix, 'icon')}
          />
        </div>
      );
    }

    if (!props.icon && props.tags) {
      const isLoggedIn = props.isLoggedIn ? props.isLoggedIn : false;
      return (
        <div className={cs(css.wrap4icon, {[css.button]: props.readOnly}, 'qa-field')}
          data-isLoggedIn={isLoggedIn} onClick={props.onSelectBroker}
        >
          {input}
          {props.tags
            ? <Tags wrapperClassName={cs(css.tagsWrap, {
              [css.tagsWrapAligned]: (props.tallInput || props.hugeInput),
              [css.tagsHuge]: (props.hugeInput),
            })} data-qa={dataQa(prefix, 'tags')} tags={props.value}
              hugeTag={props.hugeInput}
            />
            : null
          }
        </div>
      );
    }

    return input;
  }

  saveInput(node) {
    this.input = node;
    if (this.props.onMount) {
      this.props.onMount(node);
    }
  }

  onFocus(ev) {
    const autoFocused = this.state && this.state.willAutoFocus;
    if (autoFocused) {
      this.setState({willAutoFocus: false});
    }
    if (this.props.onFocus) {
      this.props.onFocus(ev, autoFocused);
    }
  }
}

export default connect((state) => {
  const isLoggedIn = state.user.isLoggedIn;
  return {isLoggedIn};
})(LabeledInput);



// WEBPACK FOOTER //
// ./src/components/common/LabeledInput/index.js